module.exports = __webpack_public_path__ + "static/media/daisy-jones-and-the-six.12d50cdb.jpg";